import { render, staticRenderFns } from "./DetalleSede.vue?vue&type=template&id=5865d95a&"
import script from "./DetalleSede.vue?vue&type=script&lang=js&"
export * from "./DetalleSede.vue?vue&type=script&lang=js&"
import style0 from "./DetalleSede.vue?vue&type=style&index=0&id=5865d95a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports